'use client'

import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { toast } from 'sonner'

import { useAuthStore } from '@/stores/auth.store'
import { authApi } from '../api'
import type { LoginInput } from '../schemas'

export function useLogin() {
  const router = useRouter()
  const login = useAuthStore((s) => s.login)
  const setCities = useAuthStore((s) => s.setCities)
  const setActiveCityId = useAuthStore((s) => s.setActiveCityId)

  return useMutation({
    mutationFn: (input: LoginInput) => authApi.login(input),
    onSuccess: (data) => {
      login(data.token, data.user, data.refreshToken)
      if (data.cities?.length) {
        setCities(data.cities)
        setActiveCityId(data.cities[0].id)
      }
      toast.success('Login realizado com sucesso')
      router.push('/overview')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Falha ao fazer login')
    },
  })
}
